import type { ReactElement } from 'react'
import { NavLink } from 'react-router-dom'
import { DropdownMenu } from '../../../components/DropdownMenu'
import type { NavigationProps } from './types'

interface MobileNavigationProps extends NavigationProps {
  isOpen: boolean
  onClose?: () => void
}

export function MobileNavigation({
  isOpen,
  items,
  openDropdowns,
  toggleDropdown,
  onClose,
}: MobileNavigationProps): ReactElement | null {
  if (!isOpen) return null

  return (
    <div className="absolute top-full right-0 left-0 z-50 border-gray-200/80 border-b bg-white/95 p-3 shadow-xl backdrop-blur-xl sm:hidden">
      <ul className="space-y-1">
        {items.map((item) => (
          <li key={item.label}>
            {item.href ? (
              item.href.startsWith('http') ? (
                <a
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={onClose}
                  className="block rounded-xl px-3.5 py-2.5 font-medium text-gray-700 text-sm transition-colors hover:bg-gray-100 hover:text-gray-900"
                >
                  {item.label}
                </a>
              ) : (
                <NavLink
                  to={item.href}
                  onClick={onClose}
                  className={({ isActive }) =>
                    `flex items-center justify-between rounded-xl px-3.5 py-2.5 font-medium text-sm transition-colors ${
                      isActive
                        ? 'bg-indigo-50 font-semibold text-indigo-700'
                        : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                    }`
                  }
                >
                  <span>{item.label}</span>
                </NavLink>
              )
            ) : item.onClick ? (
              <button
                type="button"
                onClick={() => {
                  item.onClick?.()
                  onClose?.()
                }}
                className="flex w-full items-center justify-between rounded-xl px-3.5 py-2.5 font-medium text-gray-700 text-sm transition-colors hover:bg-gray-100 hover:text-gray-900"
              >
                <span>{item.label}</span>
              </button>
            ) : (
              <DropdownMenu
                item={item}
                isOpen={openDropdowns[item.label]}
                toggleDropdown={toggleDropdown}
                isMobile
              />
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}
